import { IsUUID } from 'class-validator';

export interface ChatUnreadCounts {
    items: { chatUuid: string; unreadCount: number }[];
}

export interface ChatReadState {
    chatUuid: string;
    lastReadMessageUuid: string;
}

export class ChatMarkReadRequest {
    @IsUUID()
    public readonly chatUuid: string;

    @IsUUID()
    public readonly throughMessageUuid: string;

    constructor(data?: Partial<ChatMarkReadRequest>) {
        this.chatUuid = data?.chatUuid;
        this.throughMessageUuid = data?.throughMessageUuid;
    }
}
